import { render, staticRenderFns } from "./paymentinfo.vue?vue&type=template&id=295ddf5c&scoped=true&"
import script from "./paymentinfo.vue?vue&type=script&lang=js&"
export * from "./paymentinfo.vue?vue&type=script&lang=js&"
import style0 from "./paymentinfo.vue?vue&type=style&index=0&id=295ddf5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ddf5c",
  null
  
)

export default component.exports